import React from 'react'
import { imageUrl } from '@libs/appUrl'
import styled from 'styled-components'
import Like from '@components/Like'
import tw from 'twin.macro'
import useGetArticleCardInfo from './useGetArticleCardInfo'
import ImageWithFallback from '@components/ImageWithFallback'

const CoverImageContainer = styled.div`
  padding-bottom: 52%;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
`

const CoverImage = styled(ImageWithFallback)`
  border-radius: 8px;
  display: block;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform ease-in-out 0.15s;
`

const TitleContainer = styled.div`
  ${tw`font-semibold text-article text-gray-800`}
  margin-top: 10px;
  margin-bottom: 6px;
`

const FooterContainer = styled.div`
  display: flex;
  align-items: center;
`

const LikeContainer = styled.div`
  margin-left: auto;
`

const ArticleCardContainer = styled.div`
  &:hover {
    ${CoverImage} {
      transform: scale(1.1, 1.1);
    }
  }
`

const DesktopUserArticleCard = (props) => {
  const { article } = props

  const {
    handleClickLike,
    postID,
    coverImage,
    dateTime,
    formatted,
    isLike,
    like,
    title,
    postLink,
    coverImageFallbackSrc,
    handleArticleClick,
  } = useGetArticleCardInfo({ article })

  return (
    <ArticleCardContainer onClick={handleArticleClick}>
      <a href={postLink}>
        <CoverImageContainer>
          <CoverImage src={imageUrl(coverImage.thumb)} fallbackSrc={coverImageFallbackSrc} />
        </CoverImageContainer>
        <TitleContainer>{title}</TitleContainer>
        <FooterContainer>
          <time tw="text-gray-400 text-h6" dateTime={dateTime}>
            {formatted}
          </time>
          <LikeContainer>
            <Like id={postID} likeNum={like} isLike={isLike} onClickLike={handleClickLike} />
          </LikeContainer>
        </FooterContainer>
      </a>
    </ArticleCardContainer>
  )
}

export default DesktopUserArticleCard
